<template>
  <!-- NavBar/ -->
  <Sidebar :loged="loged" :userl="userl" />
  <router-view/>
  
  <!-- Notificación de actualización -->
  <UpdateNotification 
    :show="showUpdateNotification" 
    @update="handleUpdate"
    @dismiss="handleDismiss"
  />
</template>

<script setup>
  import { ref, onMounted, onBeforeUnmount } from 'vue';
  //import NavBar from '@/components/NavBar.vue';
  import Sidebar from '@/components/SideBar.vue';
  import UpdateNotification from '@/components/UpdateNotification.vue';
  import { updateApp } from '@/registerServiceWorker';

  const loged = ref(false)
  const userl = ref('')
  const showUpdateNotification = ref(false)
  
  // Función para manejar la actualización
  const handleUpdate = () => {
    updateApp()
  }
  
  // Función para cerrar la notificación
  const handleDismiss = () => {
    showUpdateNotification.value = false
  }
  
  // Listener para el evento de actualización del Service Worker
  const onSWUpdated = () => {
    console.log('Service Worker actualizado, mostrando notificación')
    showUpdateNotification.value = true
  }
  
  onMounted( ()=>{
    let auth = JSON.parse(localStorage.getItem('spx_localdata'));
    if(auth){
        loged.value = true;
        userl.value = auth.spx_use_p;
    }
    
    // Escuchar evento de actualización del Service Worker
    document.addEventListener('swUpdated', onSWUpdated)
  })
  
  onBeforeUnmount(() => {
    // Limpiar listener al desmontar
    document.removeEventListener('swUpdated', onSWUpdated)
  })
</script>

<style>
.offline{
  background-color: darkgoldenrod;
  color: white;
  text-align: center;
}
.desborDato{
  background-color: rgb(1, 24, 66);
  color: white;
  text-align: center;
}
</style>